import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ModalTodayCloseBtn = styled.div`
  ${mixin.flex({ justify: 'space-between' })};
  background: #fff;
  height: 39px;
  padding: 0 10px;
  width: 100%;

  .btn {
    font-weight: 500;
    font-size: 15px;
    line-height: 39px;
    height: 39px;
    padding: 0 10px;
    color: #777;

    &.btn-close {
      color: #000;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('39')};
    padding: ${mixin.pxToVw('0 10')};

    .btn {
      font-size: ${mixin.pxToVw('15')};
      line-height: ${mixin.pxToVw('39')};
      height: ${mixin.pxToVw('39')};
      padding: ${mixin.pxToVw('0 10')};
    }
  }
`;
